<template>
	<v-dialog v-model="showDialog" persistent scrollable max-width="1150px" style="z-index: 1019;">
		<v-card>
			<v-card-title style="padding: 5px 0 0 5px;">
				<v-col cols="12">
					<span style="font-size: 20px;">
						{{ $t('wkt.admin.customers.dialog_import_employees') }}
					</span>
				</v-col>
			</v-card-title>
      <v-divider></v-divider>
			<v-card-text class="pt-4 d-flex justify-start align-start">
				<v-icon v-if="isError" x-large color="red">error</v-icon>
				<v-icon v-if="!isError" x-large color="blue">info</v-icon>
				<span class="ml-4 mt-2" v-html="html" style="font-size: 16px; color: #000;"></span>
			</v-card-text>
      <v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn v-if="!isError" color="primary" text @click="ok(false)">{{ $t('wkt.admin.common.dialog-buttons.ok') }}</v-btn>
				<v-btn v-if="!isError" text @click="ok(true)">{{ $t('wkt.admin.common.dialog-buttons.cancel') }}</v-btn>
				<v-btn v-if="isError" text @click="showDialog = false">{{ $t('wkt.admin.common.dialog-buttons.close') }}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
 
  export default {
    name: 'ImportEmployeesDialog',
    data() {
        return { 
          html: null,
					isError: false,
          showDialog: false,
					cbMsg: null,
        }
    },  
    methods: {
        open(html, isError, cbMsg) { 
            this.html = html;
						this.isError = isError;
						this.cbMsg = cbMsg;

            this.showDialog = true;
        },
        ok(deleteFile) {
            this.showDialog = false;
						if (this.cbMsg) {
							this.cbMsg(deleteFile);
						}
        },
      },
  }
</script>